import pagination from '@iso/lib/helpers/pagination';

const {
    actions: baseActions,
    types,
    reducer,
} = pagination('productTypes');

const actions = {
    requestFetchProductTypes: baseActions.request,
    fetchProductTypesSucceeded: baseActions.succeeded,
    fetchProductTypesFailed: baseActions.failed,
};

export { types, actions };

export default reducer;